import { API_ENDPOINTS, DASHBOARD_APP_URL } from "../../constants";
import axiosInstance from "../../core/apiService/webApiService";


const fetchNetworksList = async (payload:any,token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await axiosInstance.get(`${DASHBOARD_APP_URL}${API_ENDPOINTS.N2N_ACTIVATION.FETCH_NETWORKS}`,config);
  return response.data;
};

const fetchRoleList = async (payload:any,token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await axiosInstance.get(`${DASHBOARD_APP_URL}${API_ENDPOINTS.N2N_ACTIVATION.FETCH_ROLES}`,config);
  return response.data;
};

const fetchSpecilialtyList = async (payload:any,token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await axiosInstance.get(`${DASHBOARD_APP_URL}${API_ENDPOINTS.N2N_ACTIVATION.FETCH_SPECLITIES}?role=${payload?.role}`,config);
  return response.data;
};

const fetchUsersList= async (payload:any,token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await axiosInstance.get(`${DASHBOARD_APP_URL}${API_ENDPOINTS.N2N_ACTIVATION.FETCH_USERS}?speciality_id=${payload?.specialityID}&role_id=${payload?.roleId}`,config);
  return response.data;
};

const activateN2N= async (payload:any,token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await axiosInstance.post(`${DASHBOARD_APP_URL}${API_ENDPOINTS.N2N_ACTIVATION.ACTIVATE_N2N}`,payload,config);
  return response.data;
};

const fetchN2NDetials= async (payload:any,token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await axiosInstance.get(`${DASHBOARD_APP_URL}${API_ENDPOINTS.N2N_ACTIVATION.FECTH_N2N_DETAILS}`,config);
  return response.data;
};


const n2nService = {
  fetchNetworksList,
  fetchRoleList,
  fetchSpecilialtyList,
  fetchUsersList,
  activateN2N,
  fetchN2NDetials
};

export default n2nService;